// Importing the default export
globalThis.selectedClasses = 'relative flex w-fit cursor-pointer items-center rounded-full border px-2.5 py-1 text-sm leading-tight select-none text-neutral-on-accent border-accent-border bg-accent-background font-medium'
globalThis.unselectedClass = 'relative flex w-fit cursor-pointer items-center rounded-full border px-2.5 py-1 text-sm leading-tight select-none text-neutral-subtle hover:text-neutral-on-accent border-transparent';

globalThis.updateFilters = function (element, event) {
    element.parentNode.querySelectorAll(`[data-type='listingboxfilter']`).forEach((item) => {
        item.classList = unselectedClass;
    })
    element.classList =selectedClasses;
}

globalThis.updateListingCanonical = function () {
    const canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) return;

    const canonicalUrl = new URL(canonical.href);
    if (canonicalUrl.pathname !== window.location.pathname) return;

    canonicalUrl.search = '';
    const currentParams = new URLSearchParams(window.location.search);
    const canonicalParams = new URLSearchParams();
    for (const [key, page] of currentParams) {
        const match = key.match(/^listing:([^:]+):page$/);
        if (!match || !/^\d+$/.test(page) || Number(page) < 2) continue;

        if (!document.getElementById('listing-results-' + match[1])) continue;

        const filtersKey = `listing:${match[1]}:filters`;
        for (const [filterKey, filterValue] of currentParams) {
            if (filterKey === filtersKey || filterKey.startsWith(filtersKey + '[')) {
                canonicalParams.append(filterKey, filterValue);
            }
        }
        canonicalParams.set(key, page);
    }

    canonicalUrl.search = canonicalParams.toString().replace(/\+/g, '%20');
    canonical.href = canonicalUrl.href;
}


globalThis.pushUrl = function (element, event) {
    let link = element.getAttribute('hx-get') || element.getAttribute('href');
    if (!link || !link.includes('?')) return;
    link = link.split('?')[1];
    const pageParams = new URLSearchParams();
    const urlParams = new URLSearchParams(link);
    const prefix = urlParams.get('target');
    const keys = urlParams.keys();

    for (const key of keys) {
        if (key !== 'target' && key !== 'siteUri') {
            pageParams.set('listing:' + prefix + ':' + key, urlParams.get(key));
        }
    }
    window.history.pushState(null, null, '?' + pageParams);
    updateListingCanonical();
}

globalThis.pushUrlMeinBereich = function (element, event) {
    // fetch link of current filter
    let link = element.getAttribute('hx-get') || element.getAttribute('href');
    if (!link || !link.includes('?')) return;
    link = link.split('?')[1];

    // transform into urlparams for better handling
    let urlParams = new URLSearchParams(link);
    const target = urlParams.get('target');
    const keys = urlParams.keys();

    // fetch current url
    const pageParams = new URLSearchParams(window.location.search);

    // set new parameters of activated filters
    for (const key of keys) {
        if (key !== 'target') {
            pageParams.set('listing:' + target + ':' + key, urlParams.get(key));
        }
    }
    window.history.pushState(null, null, '?' + pageParams);
    updateListingCanonical();
}

window.addEventListener('popstate', updateListingCanonical);

function removePillsOnSpecificPages() {
    const currentPath = window.location.pathname;

    // Matcht /[shortcut], /[shortcut]/heftausgaben, /[shortcut]/arbeitshilfen und /[shortcut]/newsletter
    const isTargetPage = /^\/[^\/]+(?:\/?|\/heftausgaben\/.*|\/arbeitshilfen\/?|\/newsletter\/.*)$/.test(currentPath);
    if (isTargetPage) {
        const style = document.createElement('style');
        style.textContent = '.iww-badge-pill { display: none !important; }';
        document.head.appendChild(style);
    }
}

removePillsOnSpecificPages();
window.addEventListener('DOMContentLoaded', function (event) {
    const pageParams = new URLSearchParams(window.location.search);
    let node_ids = [];
    for (const key of pageParams.keys()) {
        let node_id = key.split(':')[1] ? key.split(':')[1] : '';
        if (!node_ids.includes(node_id)) {
            node_ids.push(node_id);
        }
    }
    for (const key_selection of node_ids) {
        const selectedItem = pageParams.get('listing:' + key_selection + ':selected');
        if(selectedItem){
            document.getElementById('id_' + key_selection).querySelectorAll(`[data-type='listingboxfilter']`).forEach((item) => {
                if (item.getAttribute('id') === selectedItem) {
                    item.classList = selectedClasses;
                } else {
                    item.classList = unselectedClass;
                }
            });
        }
    }
})
